"use client";

import type { BlokProps } from "@frend-digital/storyblok";
import type { BlokPointsInfoBox } from "@/storyblok";
import { RichTextRender } from "@/components/ui/RichTextRender";
import { ButtonBlok } from "../ButtonBlok";
import styles from "./PointsInfoBoxBlok.module.css";
import { classed } from "@frend-digital/ui";
const Title = classed.h2(styles.title);
const Box = classed.div(styles.box);

export const PointsInfoBoxBlok = ({ blok, preview }: BlokProps<BlokPointsInfoBox>) => {
	return (
		<Box>
			{blok.title && <Title>{blok.title}</Title>}
			{blok.points && (
				<RichTextRender blok={blok.points} preview={preview} className={styles.pointsList} />
			)}
			{blok.button && blok.button.length > 0 && (
				<div className={styles.buttonWrapper}>
					{blok.button.map((button) => (
						<ButtonBlok key={button._uid} blok={button} preview={preview} />
					))}
				</div>
			)}
		</Box>
	);
};
